module.exports = __webpack_public_path__ + "static/media/sweetcorn.b770db7e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/toppings/sweetcorn.jpg
// module id = 138
// module chunks = 0